import { CheckMarkList } from '@/components/RequestDemo/CheckMarkList';
import Image from 'next/image';
import { FC } from 'react';

const SocialProofContent: FC = () => {
  return (
    <div className='relative bg-violet-200 min-h-85'>
      <div className="relative z-1 px-6 py-10">
        <p className="py-[12px]">
          Discover how to boost agent efficiency and deliver seamless service with Front, the only platform with:
        </p>
        <div className="py-3">
          <CheckMarkList items={[
            'A unified workspace for every customer interaction',
            'AI-powered workflows for unmatched efficiency',
            'Fast, easy deployment and rapid ROI',
            'Award-winning support with 97%+ CSAT',
          ]} />
        </div>
      </div>
      <Image className="absolute bottom-0" src="https://front.com/webassets/rebrand/demo-modal-right-rail-image.png" alt="Dashboard illustration" width={542} height={300} />
    </div>
  )
}

export default SocialProofContent;
